// NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound404Page = () => {
    return (
        <div className="notfound-container">
            <h1 className="notfound-title">404</h1>
            <p className="notfound-subtitle">Oops! Page not found.</p>
            <p className="notfound-text">The page you’re looking for doesn’t exist or has been moved.</p>
            <Link to="/" className="notfound-button">Go to Homepage</Link>
        </div>
    );
};

export default NotFound404Page;
